import React, { useState } from "react";
import { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useLocation, Outlet } from "react-router-dom";
import { Provider, useSelector } from "react-redux";
import { store } from "./store/store.js";
import { ToastContainer } from "react-toastify";
import styled from "styled-components";

import Footer from "./common/footer.jsx";
import Header from "./common/header.jsx";
import useUserAuthActions from "./hooks/useUserStorage.jsx";

const CustomToast = styled(ToastContainer)`
  z-index: 10000;
  width: "400px";
  font-weight: 600;
  font-size: 16px;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

const AppGroup = () => {
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const { checkAndLogin } = useUserAuthActions();
  const user = useSelector((state) => state?.user?.data[0]);

  useEffect(() => {
    document.title = "모노티 모임";

    if (!window.Kakao || !window.Kakao.isInitialized()) {
      // Kakao.init("b9886faecde9faa67a51166600a9d107"); // 개발 환경에 맞는 API 키 사용
      Kakao.init("4970bf08e349ccf4b295296035944317"); // 운영 환경에 맞는 API 키 사용
    }

    if (!user) {
      checkAndLogin();
    }
  }, [user, checkAndLogin]);

  function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
      changeBodyClassName();
    }, [pathname]);

    return null;
  }

  return (
    <Provider store={store}>
      <ScrollToTop />
      <CustomToast
        position="top-center"
        theme="light"
        pauseOnHover
        hideProgressBar={true}
        autoClose={1000}
        closeButton={false}
      />
      <Header type="group" />
      <Outlet />
      <Footer />
    </Provider>
  );
};

export default AppGroup;
